import { useTranslation } from 'react-i18next';
import dayjs from '@ivario-arc/shared/src/utils/dayjs.ts';
import { SampleDto } from '@src/types/types';
import { UserDataItem } from './UserDataItem';

interface UserInfoDataProps {
  sample: SampleDto;
  isExpanded: boolean;
}

export const UserInfoData: React.FC<UserInfoDataProps> = ({
  sample,
  isExpanded,
}) => {
  const { t: tDate } = useTranslation('date');

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
      <UserDataItem
        translationKey="samplingLocation"
        value={sample.collectionPoint}
      />
      {!isExpanded &&
      (sample.samplingStreet ||
        sample.samplingStreetNumber ||
        sample.samplingCity ||
        sample.samplingPostalCode) ? (
        <UserDataItem
          translationKey="address"
          value={`${sample.samplingStreet} ${sample.samplingStreetNumber} ${
            (sample.samplingStreet || sample.samplingStreetNumber) &&
            (sample.samplingCity || sample.samplingPostalCode)
              ? ', '
              : ' '
          } ${sample.samplingPostalCode} ${sample.samplingCity}`}
        />
      ) : (
        <div></div>
      )}

      {isExpanded && (
        <>
          <UserDataItem
            translationKey="samplingPerson"
            value={sample.sampler}
          />
          <UserDataItem
            translationKey="companyName"
            value={sample.companyName}
          />
          <UserDataItem
            translationKey="samplingDate"
            value={
              sample.collectionDate
                ? dayjs(sample.collectionDate).format(tDate('format'))
                : undefined
            }
          />
          <UserDataItem
            translationKey="samplingTime"
            value={sample.collectionTime}
          />
          <UserDataItem translationKey="street" value={sample.samplingStreet} />
          <UserDataItem
            translationKey="houseNumber"
            value={sample.samplingStreetNumber}
          />
          <UserDataItem
            translationKey="postalCode"
            value={sample.samplingPostalCode}
          />
          <UserDataItem translationKey="city" value={sample.samplingCity} />
          <UserDataItem
            translationKey="notes"
            value={sample.notes}
            className="md:col-span-2"
          />
        </>
      )}
    </div>
  );
};
